import { useTranslation } from "../../hooks/useTranslation";

export function Pagination({total_pages, rows_per_page, page, setPage}) {
    const { t } = useTranslation();
    return (
        <div className="d-flex flex-stack flex-wrap pt-10">
            <div className="fs-6 fw-semibold text-gray-700">
                {t("common.pagination", { page, total_pages, rows_per_page })}
            </div>

            <ul className="pagination">
                {page > 1 && (
                    <li className="page-item previous">
                                <span onClick={() => {
                                    setPage(page - 1)
                                }} className="page-link">
                                    <i className="previous"></i>
                                </span>
                    </li>
                )}
                {[...Array(parseInt(total_pages)).keys()].map((page_minus_1) => (
                    (((page - 4) < page_minus_1 && (page + 2) > page_minus_1) || page_minus_1 == 0 || page_minus_1+1==total_pages) && (
                        <li className={"cursor-pointer page-item " + (page == page_minus_1 + 1 ? "active" : "")}>
                                <span onClick={() => {
                                    setPage(page_minus_1 + 1)
                                }} className="page-link">
                                    {page_minus_1 + 1 == 1 ? t("common.first") : page_minus_1 + 1 == total_pages ? t("common.last") : page_minus_1 + 1}
                                </span>
                        </li>
                    )
                ))}
                {page < total_pages && (
                    <li className="page-item next">
                            <span onClick={() => {
                                setPage(page + 1)
                            }} className="page-link">
                                <i className="next"></i>
                            </span>
                    </li>
                )}
            </ul>

        </div>
    )
}